import { RefObject, useEffect, useRef } from 'react'
import { useReducedMotion } from './useReducedMotion'

/**
 * Scales up and fades the collage wall as the hero scrolls out of view,
 * mirroring the depth effect from the source design.
 */
export function useHeroParallax(wallRef: RefObject<HTMLDivElement>) {
  const reducedMotion = useReducedMotion()
  const frame = useRef(0)

  useEffect(() => {
    if (reducedMotion) return

    const update = () => {
      frame.current = 0
      const wall = wallRef.current
      if (!wall) return
      const progress = Math.max(0, Math.min(1, window.scrollY / (window.innerHeight * 0.95)))
      const scale = 1.04 + progress * 0.55
      const opacity = 1 - Math.max(0, Math.min(1, (progress - 0.55) / 0.35))
      wall.style.transform = `scale(${scale})`
      wall.style.opacity = String(opacity)
    }

    const queueUpdate = () => {
      if (!frame.current) frame.current = requestAnimationFrame(update)
    }

    update()
    window.addEventListener('scroll', queueUpdate, { passive: true })
    return () => {
      window.removeEventListener('scroll', queueUpdate)
      if (frame.current) cancelAnimationFrame(frame.current)
    }
  }, [reducedMotion, wallRef])
}
